import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/partner-crms`;
export const modelName = 'crm-partner';

export default {
  ...apiCrud({ baseUri, modelName }),
};
